import React from "react";
import {useParams} from 'react-router-dom'
import {RequestDetailHeader} from "./RequestDetailHeader";
import {RequestDetailOverview} from "./RequestDetailOverview";

export function RequestDetail(props) {
    const params = useParams();
    const LocationTracker = props.LocationTracker;
    return (
        <>
            <LocationTracker location="Flow overview" sublocation="Detail"
                        traceId={params.traceId} />
            <RequestDetailHeader traceId={params.traceId} retriggerService={props.retriggerService} />
            <br/>
            <RequestDetailOverview traceId={params.traceId} structuredLogsService={props.structuredLogsService}/>
        </>
    );
}

